import SocialCompanyListItemPeopleShort from "models/social/SocialCompanyListItemPeopleShort";

const SocialCompanyListItemPeopleLinkShort = ({
  object: social,
  ratingKey,
}) => {
  return (
    <SocialCompanyListItemPeopleShort
      object={social.people}
      ratingKey={ratingKey}
    />
  );
};

export default SocialCompanyListItemPeopleLinkShort;
